import { auth } from "@/config/firebase"
import axios from "axios";

const axiosInstance = axios.create({
	baseURL: process.env.VUE_APP_PYTHON_BACKEND_URL + '/api/v1',
});

axiosInstance.interceptors.request.use(
	async (config) => {
		const user = auth.currentUser;
		if(user){
			const token = await user.getIdToken();
			config.headers['token'] = token;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

axiosInstance.interceptors.response.use(
	(response) => { 
		return response;
	},
	async (error) => {
		const originalRequest = error.config;
		
		if ((error.response?.status === 401 || error.response?.status === 403) && !originalRequest._retry) {
			originalRequest._retry = true;

			try {
				const user = auth.currentUser;
                
                if (!user) {
                    window.location.replace("/login");
                    return Promise.reject(error);
                }

                const freshToken = await user.getIdToken(true);
                originalRequest.headers['token'] = freshToken;
                return axiosInstance(originalRequest);
			} catch (error) {
                window.location.replace("/login");
                return Promise.reject(error);
			}
		}
		return Promise.reject(error)
	}
);

export default axiosInstance;